export default __webpack_public_path__ + "static/media/modal5.9930c522.png";